export default __webpack_public_path__ + "static/media/group-option-noglasses-selected.5cb6c6b5.svg";